"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundIndexRequest = void 0;
var FundIndexRequest = /** @class */ (function () {
    function FundIndexRequest() {
    }
    return FundIndexRequest;
}());
exports.FundIndexRequest = FundIndexRequest;
;
//# sourceMappingURL=fundIndex.request.js.map